import { render, staticRenderFns } from "./InvestmentsMainSection.vue?vue&type=template&id=359dd677"
import script from "./InvestmentsMainSection.vue?vue&type=script&lang=js"
export * from "./InvestmentsMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports